import { IBanksResponse } from "src/interfaces/banks";
import { PAYMENT_FLOW_TYPE, STATUS_TYPE } from "src/constants/storesPromos";

import { ChipOption } from "./global";
import { IError, IMetaData } from "./services";

export enum EPromotionCalculatedStatus {
    RUNNING = 'running',
    ALL = 'all',
    FINISHED = 'finished',
    VISIBLE_NOT_APPLICABLE = 'visible_not_applicable',
}

export enum EInstallmentType {
    WITH_INSTALLMENTS = 'con_interes',
}

export enum ECardsType {
    CLASSIC_FREE_CONTENT = 'classic_free_content',
}

export const PromotionStatusActive = 'active';

export const PROMOTION_STATUS_DICT = {
    [EPromotionCalculatedStatus.ALL] : 'Todas',
    [EPromotionCalculatedStatus.RUNNING] : 'Activa',
    [EPromotionCalculatedStatus.FINISHED] : 'Finalizada',
    [EPromotionCalculatedStatus.VISIBLE_NOT_APPLICABLE] : 'Finalizada',
};

export type IPromotionFilterProps = {
    search_text?: string;
    fcalcstatus?: string[];
    companies_id?: string[];
};

export interface IPromotionData {
    id: string;
    title?: string;
    company_id?: string;
    start_date?: string;
    stop_date?: string;
    days_of_week?: string;
    status?: string;
    calculated_status?: EPromotionCalculatedStatus.RUNNING | EPromotionCalculatedStatus.FINISHED | EPromotionCalculatedStatus.VISIBLE_NOT_APPLICABLE;
    investment?: number;
    to_debit_amount?: number;
    to_pay_amount?: number;
}

export interface IStoresPromotionData {
    id: string;
    title: string;
    start_date: string;
    stop_date: string;
    payment_flow?: PAYMENT_FLOW_TYPE;
    days_of_week: string;
    calculated_status?: string;
    status: STATUS_TYPE;
}

export interface IStoresPromotionResponse {
    metadata?: IMetaData;
    data?: {
        promotions: IStoresPromotionData[],
    };
    error?: IError;
}

export interface IPromotionDetailData {
    promotion_id?: string;
    file_name?: string;
    reconciliation_file_id?: string;
    start_period?: string;
    end_period?: string;
    status?: string;
    paid_at?: string;
    bank_id?: string;
    company_id?: string;
    total_operations_amount?: string;
    total_rejected_amount?: string;
    total_rejected_to_reprocess?: string;
    total_all_rejected_amount?: string;
    total_to_paid?: string;
    total_paid?: string;
}
  
export interface IPromotionsResponse {
    error?: IError;
    data?: { promotions?: IPromotionData[] };
    metadata?: IMetaData;
}

export interface IPromotionDetailsResponse {
    error?: IError;
    data?: { reconciliationFiles?: IPromotionDetailData[] };
    metadata?: IMetaData;
}

export const STATUS_FILTER_OPTIONS : ChipOption[] = [
    {
        key: EPromotionCalculatedStatus.ALL,
        name: PROMOTION_STATUS_DICT[EPromotionCalculatedStatus.ALL]
    },
    {
        key: EPromotionCalculatedStatus.RUNNING,
        name: PROMOTION_STATUS_DICT[EPromotionCalculatedStatus.RUNNING]
    },    
    {
        key: EPromotionCalculatedStatus.FINISHED,
        name: PROMOTION_STATUS_DICT[EPromotionCalculatedStatus.FINISHED]
    },
];

export interface IInstallments {
    type: EInstallmentType.WITH_INSTALLMENTS;
    number: number;
    total_financial_cost: string;
    annual_nominal_rate: string;
    coefficient: string;
}

export interface IPeriodParams {
    day_of_week: string;
    day_of_month: number;
    custom_date: string;
}
export interface IOverwriteDdPeriod {
    period_type: string;
    period_params: IPeriodParams;
}

export interface IOverwriteProbability {
    order: number;
    probability: number;
}

export interface IPrizeValues {
    amount: number;
    probability: number;
    overwrite_probability: IOverwriteProbability[];
    image: string;
}

export interface ITriggerParams {
    cap_type: string;
    store_key: string;
    cap_amount: number;
    cap_period: string;
    debit_list: string[];
    min_amount: number;
    credit_list: string[];
    installments: IInstallments[];
    store_value: string;
    apply_to_pct: boolean;
    bank_percent: number;
    modo_percent: number;
    issuer_percent: number;
    cap_promotion: number;
    discount_mode: string;
    apply_to_debit: boolean;
    apply_to_credit: boolean;
    cap_transaction: number;
    cashback_method: boolean;
    pct_promo_value: number;
    merchant_percent: number;
    promo_value_type: string;
    cap_amount_period: number;
    debit_promo_value: number;
    credit_promo_value: number;
    class_type: string;
    acquirer_segmentation: string;
    acquirer_list: string[];
    use_direct_debit: boolean;
    overwrite_dd_period: IOverwriteDdPeriod;
    prize_values: IPrizeValues[];
    challenge_id: number;
}

export interface IImages {
    id: string;
    title: string;
    landscape_web: string;
    landscape_app: string;
    portrait_web: string;
    portrait_app: string;
    square_web: string;
    square_app: string;
    landscape_bgcolor: string;
    portrait_bgcolor: string;
    square_bgcolor: string;
    created_at: string;
    updated_at: string;
}

export interface IRow {
    text: string;
    forecolor: string;
    backgroundcolor: string;
}

export interface IContentImage {
    primary_image: string;
    secondary_image: string;
    tertiary_image: string;
    primary_backgroundcolor: string;
    secondary_backgroundcolor: string;
    tertiary_backgroundcolor: string;
}

export interface IContent {
    row: IRow;
    image: IContentImage;
}

export interface ICards {
    id: string;
    type: ECardsType.CLASSIC_FREE_CONTENT;
    status: string;
    backgroundcolor: string;
    content: IContent;
    extra_params: string;
    created_at: string;
    updated_at: string;
    deleted_at: string;
}

export interface ISection {
    id: string;
    promotion_id: string;
    bank_id: string;
    section_type: string;
    background_color: string;
    title_color: string;
    description_color: string;
    created_at: string;
    updated_at: string;
    contents: string[];
}

export interface IAudienceWhitelist {
    audiences: string[];

}

export interface IAssociatedPromotionFields {
    source: string;
    required: boolean;
    completed: boolean;
}

export interface IComponent {
    key: string;
    enabled: boolean;
    completed: boolean;
    order: number;
    associated_promotion_fields: IAssociatedPromotionFields[];
}

export interface IPage {
    key: string;
    title: string;
    position: number;
    completed: boolean;
    components: IComponent[];
}

export interface IFormFieldStatus {
    status: string;
    created_from: string;
    pages: IPage[];
}

export interface INewPromotionResponse {
    id: string;
    title: string;
    slug: string;
    short_description: string;
    description: string;
    where: string;
    start_date: string;
    stop_date: string;
    days_of_week: string;
    daily_start_time: string;
    daily_stop_time: string;
    status: string;
    promo_visibility: string;
    feed_visibility: string;
    payment_visibility: string;
    exclusiveness: string;
    search_tags: string;
    is_public: boolean;
    created_at: string;
    updated_at: string;
    deleted_at: string;
    trigger_type: string;
    payment_flow: string;
    trigger_params: ITriggerParams;
    visibility_start_date: string;
    visibility_stop_date: string;
    hd_params_engine: string;
    stores_whitelist: string;
    users_whitelist: boolean;
    images: IImages;
    cards: ICards;
    promotion_type: string;
    sections: ISection[];
    bins_whitelist: boolean;
    national_id_whitelist: boolean;
    mcc_whitelist: boolean;
    audience_whitelist: IAudienceWhitelist;
    categories_whitelist: string;
    form_field_status: IFormFieldStatus;
    banks: IBanksResponse;
}
